exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report[data-v-0c7b5fb8]{margin-top:30px}.center[data-v-0c7b5fb8]{text-align:center}.btn-export[data-v-0c7b5fb8]{text-align:right;margin-bottom:.25rem}.break-word[data-v-0c7b5fb8]{word-break:break-all}.colour-pdf[data-v-0c7b5fb8]{color:red}.colour-excel[data-v-0c7b5fb8]{color:green}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0c7b5fb8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/BandejaSocios.vue
// module id = 245
// module chunks = 58